import { render, staticRenderFns } from "./MailToRead.vue?vue&type=template&id=58c012cf&"
import script from "./MailToRead.vue?vue&type=script&lang=js&"
export * from "./MailToRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports